import React, { useEffect, useState } from "react";

// plugin

// style
import "./flashHover.scss";

// context

// component

// util

// svg

// component
export default function FlashHover({ children }) {
	const [hover, setHover] = useState(false);
	useEffect(() => {
		let hoverTimeout;
		if (hover) {
			hoverTimeout = setTimeout(() => setHover(false), 50);
		}
		return () => clearTimeout(hoverTimeout);
	});

	return (
		<div
			onMouseEnter={() => setHover(true)}
			className={`flashHoverWrapper ${hover ? "hover" : ""}`}
			role="presentation"
		>
			{children}
		</div>
	);
}
